<template>
    <v-card
        class="elevation-0 mb-4"
        :max-width="$vuetify.breakpoint.mdAndUp ? '450px' : '100%'"
        id="scroller"
    >
        <v-card-text class="pa-6 pt-0">
            <h2 class="mt-3">Your Information</h2>
            <v-sheet
                tile
                color="#f9f9f9"
                class="px-5 rounded-lg py-4 mt-3"
            >
                <v-row class="position-relative">
                    <mono-payment
                        :recipientInfo="{
                            ...requestor,
                            name: `${requestor.firstname} ${requestor.lastname}`
                        }"
                    />
                </v-row>
            </v-sheet>

            <h2 class="pt-6 mt-3">
                Request Details
            </h2>
            <v-sheet
                tile
                color="#f9f9f9"
                class="px-5 rounded-lg py-4 mt-3"
            >
                <v-row>
                    <v-col class="py-0 text-left col-12 col-lg-6">
                        <p class="my-0 subtitle-1">Payment Method</p>
                    </v-col>
                    <v-col class="text-left py-0">
                        <p class="subtitle-1 my-0 font-weight-bold">
                            {{ selectedOrder.payment_method }}
                        </p>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col class="py-0 text-left col-12 col-lg-6">
                        <p class="my-0 subtitle-1">Delivery Method:</p>
                    </v-col>
                    <v-col class="text-left py-0">
                        <p class="subtitle-1 my-0 font-weight-bold">
                            {{ deliveryMethod }}
                        </p>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col class="py-0 text-left col-12 col-lg-6">
                        <p class="my-0 subtitle-1">Amount Requested:</p>
                    </v-col>
                    <v-col class="text-left py-0 d-flex d-lg-block">
                        <p class="subtitle-1 my-0 font-weight-bold">
                            {{ formatAmount(amount) }} {{ selectedOrder.matcher_currency }}
                        </p>
                        <p class="subtitle-2 my-0 teal--text text--accent-4 pt-1 pl-1 pa-lg-0">
                            ({{ roundedExchange }} {{ selectedOrder.poster_currency }}/{{ selectedOrder.matcher_currency }})
*                        </p>
                    </v-col>
                </v-row>
            </v-sheet>

            <v-row class="mt-5">
                <v-col class="py-0 d-flex">
                    <p class="my-0 subtitle-1">Fees</p>
                    <v-tooltip right v-if="coupon.description">
                        <template v-slot:activator="{ on }">
                            <v-icon
                                v-on="on"
                                class="pl-2 dense"
                                color="teal accent-4"
                                size="16"
                            >
                                mdi-information-outline
                            </v-icon>
                        </template>
                        <span>
                            {{ coupon.description }}
                        </span>
                    </v-tooltip>
                </v-col>
                <v-col class="text-right py-0">
                    <p class="subtitle-1 my-0 font-weight-bold">
                        {{ selectedOrder.fee || '0.01 - 0.98' }} {{ selectedOrder.matcher_currency }}
                    </p>
                </v-col>
            </v-row>

            <v-row>
                <v-col class="py-0 col-12 col-lg-6">
                    <p class="my-0 subtitle-1">
                        Reason for payment
                    </p>
                </v-col>
                <v-col class="text-lg-right py-0">
                    <p class="subtitle-2 my-0 mt-lg-1 font-weight-bold">
                        {{ paymentRequestPurpose }}
                    </p>
                </v-col>
            </v-row>

            <v-row>
                <v-col class="py-0 col-12 col-lg-6">
                    <p class="my-0 subtitle-1">
                        Note
                    </p>
                </v-col>
                <v-col class="text-lg-right py-0">
                    <p class="body-2 my-0 block-ellipsis">
                        {{ note }}
                    </p>
                </v-col>
            </v-row>

            <v-row>
                <v-col cols="12">
                    <v-divider class="ml-0" inset></v-divider>
                </v-col>
                <v-col class="py-0 d-flex">
                    <p class="my-0 subtitle-1 font-weight-bold" style="white-space: nowrap">
                        Recipient Receives
                    </p>
                    <v-tooltip right v-if="amountInfo">
                        <template v-slot:activator="{ on }">
                            <v-icon
                                v-on="on"
                                class="pl-2 dense"
                                color="teal accent-4"
                                size="16"
                            >
                                mdi-information-outline
                            </v-icon>
                        </template>
                        <span>
                            {{ amountInfo }}
                        </span>
                    </v-tooltip>
                </v-col>
                <v-col class="text-lg-right py-0">
                    <p class="subtitle-1 flex-grow-0 mb-0 font-weight-bold">
                        {{ recipientGets }} {{ selectedOrder.poster_currency }}
                    </p>
                </v-col>
            </v-row>
        </v-card-text>
        <!-- <v-alert v-if="selectedOrder.fake" color="warning" class="body-2 mb-0 px-6" text dense>
            Clicking the accept button will redirect you to {{ selectedOrder.company.name }}'s
            website to complete your transfer.
        </v-alert>
        <v-alert v-else color="warning" class="body-2 mb-0 px-6" text dense>
            By accepting this offer, you commit to this transaction.
            Failure to make payment within 2 hours of accepting this offer could result in a restriction/suspension of your account.
        </v-alert> -->
        <v-card-actions class="pa-6">
            <v-btn
                class="text-capitalize px-6 cancel"
                text
                color="red darken-2"
                large
                @click="$emit('cancel')"
            >
                Cancel
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
                class="text-capitalize px-10 rounded-lg"
                color="primary"
                dark
                depressed
                large
                @click="$emit('accept')"
            >
                Request
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
/* eslint-disable camelcase */
let currency = require('../../../modules/currency.js');
import { mapGetters } from 'vuex';
import MonoPayment from '../../match-confirmed-reveal-type-mono-payment';

export default {
    name: 'confirm-payment-request',
    data: data,
    components: {
        MonoPayment,
    },
    props: {
        fee: Number,
        selectedOrder: Object,
        requestor: Object,
        recipient: Object,
        paymentType: String,
        amount: Number,
        posterAmount: Number,
        paymentRequestPurpose: String,
        benefactorEmail: String,
        note: String,
        paymentMethod: String,
        couponProp: Object,
    },
    methods: getMethods(),
    computed: getComputed(),
    filters: getFilters(),
};

function data() {
    const vm = this;

    return {
        coupon: this.couponProp,
        not: this.note,
    }
}

function getComputed() {
    return {
        youSend,
        show,
        roundedExchange,
        amountInfo,
        feeAmount,
        recipientGets,
        deliveryMethod,
        ...mapGetters('deliveryMethods', {
                storeDeliveryMethods: 'deliveryMethods',
            }),
    };

    function deliveryMethod() {
        const method = this.storeDeliveryMethods.find(({ methods }) => {
            return methods.includes(this.selectedOrder.matcher_payment_method_type);
        });
        return method.name || '';
    }

    function youSend() {
        const vm = this;
        return vm.selectedOrder.amount;
    }

    function show() {
        return {
            get () {
                return this.value
            },
            set (value) {
                this.$emit('input', value)
            }
        }
    }

    function roundedExchange() {
        const vm = this;

        return vm.selectedOrder.exchange_rate;
    }

    function amountInfo() {
        const vm = this;
        const posterSymbol = vm.getCurrencySymbol(vm.selectedOrder.poster_currency);
        const matcherSymbol = vm.getCurrencySymbol(vm.selectedOrder.matcher_currency);
        const amount = vm.currencyFormat(matcherSymbol, vm.amount);
        const rate = vm.formatAmount(vm.selectedOrder.exchange_rate);
        if (vm.selectedOrder.fakeFee !== null && vm.selectedOrder.fakeFee !== undefined) {
            const fee = vm.currencyFormat(matcherSymbol, vm.selectedOrder.fakeFee);
            return `(${amount} sent - ${fee} fee) x ${rate} exchange rate`;
        } else {
            const fee = vm.currencyFormat(matcherSymbol, vm.fee);
            const discount = vm.coupon.discount ? vm.currencyFormat(matcherSymbol, vm.coupon.discount) : 0;
            return `(${amount} sent - ${fee} fee + ${discount} discount) x ${rate} exchange rate`;
        }
    }

    function feeAmount() {
        const vm = this;
        if (vm.selectedOrder.fakeFee !== null && vm.selectedOrder.fakeFee !== undefined) {
            return parseFloat(vm.selectedOrder.fakeFee).toFixed(2);
        } else {
            if (vm.coupon) {
                let discount = vm.coupon.discount;
                return parseFloat(vm.fee - discount).toFixed(2);
            } else {
                return parseFloat(vm.fee).toFixed(2);
            }
        }
    }

        function recipientGets() {
            return this.formatAmount(this.posterAmount);
        }

    function matcherSymbol() {
        const vm = this;
        return getCurrencySymbol(vm.selectedOrder.matcher_currency);
    }
}

function getMethods() {
    return {
        getCurrencySymbol,
        currencyFormat
    };

    function currencyFormat(symbol, num) {
        return symbol + num
    }

    function getCurrencySymbol(currency_code) {
        return currency.getCurrencySymbol(currency_code);
    }
}

function getFilters() {
    return {
        removeUnderscore(val) {
            return val && String(val).replace(/[_-]/g, ' ')
        },
    }
}
</script>

<style scoped>
.w-400 {
    width: 400px;
}
.note-row p {
    max-height: 100px;
    overflow-y: auto;
}
.v-image{
    margin: auto;
}
.overline{
    letter-spacing: 0.05em!important;
    line-height: 1rem;
    font-weight: bolder!important;
}

.cancel {
    background-color: #FFEDD3;
}

.v-sheet >>> .copy-button {
    display: none;
}

.block-ellipsis {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.theme--light.v-divider {
    border-color: #D2D2D2;
    max-width: 100%;
}
</style>
